import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import Show from './Show.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/kanban'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'kanban_settings_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'kanban_settings_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'kanban_settings_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: ':boardId',
          name: 'kanban_settings_show',
          meta: {
            permissions: ['administrator'],
          },
          component: Show,
          props: true,
        },
      ],
    },
  ],
};
